<template>
<div class="terms-container">
    <div class="text-container">
        <div class="title">{{$t('logout.CancelAccount')}}</div>
        <div class="t1">{{$t('logout.CanelHiLeiaMessage')}}</div>
        <div class="pane1">
            <div class="t2">{{$t('logout.BeforeCanelMessage')}}</div>
            <ul>
                <li>{{$t('logout.VerifyIdentity')}}</li>
                <li>{{$t('logout.AccountValidState')}}</li>
            </ul>
        </div>
        <div class="pane2">
            <div class="t2">{{$t('logout.CancelHiLeiaMessage')}}</div>
            <ul>
                <li>{{$t('logout.NotLogInAndUseHiLeia')}}</li>
                <li>{{$t('logout.NotAccessFriendAndCocData')}}</li>
                <li>{{$t('logout.NotAccessHistoryData')}}</li>
                <li>{{$t('logout.NotAccessAndSaveARData')}}</li>
            </ul>
        </div>
    </div>

    <div class="btn-container">
        <a-checkbox :checked="checked" @change="onChange">
            {{$t('logout.ReadAndKnow')}}<a-button type="link" class="term" @click="openTerms">{{$t('logout.HiLeiaCancelAgreement')}}</a-button>
        </a-checkbox>
        <BasicBtnGroup
            :disabled="!checked"
            :showDef="false"
            @primeClick="confirm"
            class="confirm-btn"
        >
            <span slot="primaryContent">{{$t('logout.ConfirmContinue')}}</span>
        </BasicBtnGroup>
    </div>
</div>
</template>
<script>
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'

export default {
  name: 'CancelAccountTerms',
  data() {
    return {
      checked: false
    }
  },
  components: {
    BasicBtnGroup
  },
  methods: {
    onChange(e) {
      this.checked = e.target.checked
    },
    confirm() {
      this.$emit('termsAccept')
    },
    openTerms() {
      window.open('https://www.hiar.com/protocol/hileia-cancellation')
    }
  }
}
</script>
<style scoped lang="less">
.font(@fontSize, @color, @fontWeight) {
    font-size: @fontSize;
    font-weight: @fontWeight;
    color: @color;
}
.terms-container {
    position: relative;
    height: 377px;
    padding: 17px 0;
    .text-container {
        height: 343px;
        overflow-y: scroll;
        padding: 15px 56px 115px;
        .title {
            .font(18px, #000, 500);
            margin-bottom: 12px;
        }
        .t1 {
            .font(16px, #6A6D73, 400);
        }
        .t2 {
            .font(16px, #A7ACC5, 400);
            margin-bottom: 16px;
        }
        .pane1, .pane2 {
            margin-top: 12px;
            padding: 16px;
            background: #F7F8FA;
            box-shadow: inset 5px 0px 10px 0px rgba(151, 171, 199, 0.06);
            border-radius: 8px;
            >ul {
                list-style: none;
                padding: 0 !important;
                margin: 0;
            }
            li {
                padding-left: 1em;
                text-indent: -.7em;
                .font(16px, #000, 400)
            }
            li:not(:last-child) {
                margin-bottom: 8px;
            }
            li::before {
                content: "• ";
                color: #A7ACC5;
            }
        }
    }

    .btn-container {
        position: absolute;
        width: 720px;
        height: 115px;
        left: 0;
        bottom: 0;
        padding: 37px 56px 0;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0px -10px 30px 0px rgba(89, 132, 219, 0.1);
        border-radius: 0px 0px 16px 16px;
        backdrop-filter: blur(1px);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .confirm-btn ::v-deep .ant-btn {
            padding: 10px 24px;
        }
    }
}
.term {
    .font(14px, #4266F5, 400);
    padding: 0;
}
</style>
